import $ from 'jquery';
import React, { Component } from 'react';
import { correctHeight, detectBody } from '../../theme/helpers/helpers';
import '../../assets/dependencies';
import Slider from '../../theme/slider';
import { Link } from 'react-router-dom';
import logo from '../../assets/img/logo2.png';

export default class Landing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headerClass: '',
      active: 'active',
      hover: {
        login: '',
        register: ''
      }
    };
    this.changeHeaderOn = 200;
  }

  componentDidMount() {
    // eslint-disable-next-line func-names
    $(window).bind('load resize', function() {
      correctHeight();
      detectBody();
    });
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    return (
      <div className="landing-page gray-bg">
        <div id="wrapper" className="animate">
          <nav className={`navbar header-top fixed-top navbar-expand-lg navbar-light navbar-scroll ${this.state.headerClass}`}>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText"
              aria-controls="navbarText"
              aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon" />
            </button>
            <Link className="nav-link" to="">
              <img alt="show" className="logo" src={logo} style={{ width: 220 }}/>
            </Link>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText"
              aria-controls="navbarText"
              aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon" />
            </button>
            <div className="collapse navbar-collapse" id="navbarText">
              <ul className="navbar-nav ml-md-auto d-md-flex">
                <li className="nav-item">
                  <Link className={`nav-link menu-tabs ${this.state.active}`} to="/" id="home">Trang chủ</Link>
                </li>
                {/* <li className="nav-item">
                  <Link className={`nav-link menu-tabs ${this.state.hover.register}`} name="register"
                    onMouseEnter={(e) => this.toggleHover(e, 'active')} onMouseLeave={(e) => this.toggleHover(e, '')}
                    to="/register" id="register">Register</Link>
                </li> */}
                <li className="nav-item">
                  <Link className={`nav-link menu-tabs ${this.state.hover.login}`} name="login"
                    onMouseEnter={(e) => this.toggleHover(e, 'active')} onMouseLeave={(e) => this.toggleHover(e, '')}
                    to="/login" id="login">Đăng nhập</Link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
        <Slider/>
        <section id="features" className="container services">
          <div className="row" style={{ padding: '0' }}>
            <div className="col-sm-3">
              <h2>Quản lý nhân sự</h2>
              <p>Develop various categories and versions of API's using friendly developer portal.</p>
            </div>
            <div className="col-sm-3">
              <h2>Tuyển dụng</h2>
              <p>Demonstrate your API's to consumers over consumer portal </p>
            </div>
            <div className="col-sm-3">
              <h2>Quản lý quy trình</h2>
              <p>Integrate and test API's at SIT sandbox.</p>
            </div>
            <div className="col-sm-3">
              <h2>Quản lý công việc</h2>
              <p>Promote your integration to production and enjoy 24/7 API availability.</p>
            </div>
          </div>
        </section>
        <section id="about-us" className="container features">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className="navy-line" />
              <h1>Leading the marketplace in products, services, solutions</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-center">
              <p>Dựa trên hơn 10 năm kinh nghiệm, Lac Long Quan đã phục vụ hàng chục khách hành trên khắp cả nước.
                Đặc biệt tập trung vào lĩnh vực tài chính và ngân hàng, công ty đã triển khai sản phẩm tại các đối tác lớn như Ngân Hàng BIDV, VietcomBank, Agribank, VietintBank, CB Bank, VietcomBank Sercurities, Tập đoàn TNG, LG, Bridgstone...
                Triết lý kinh doanh của chúng tôi được xây dựng dựa trên tầm quan trọng của các mối quan hệ và sự nỗ lực không ngừng để đạt được những thành tựu lớn hơn.
              </p>
            </div>
          </div>
        </section>

        <section id="contact" className="gray-section contact">
          <div className="container">
            <div className="row m-b-lg">
              <div className="col-lg-12 text-center">
                <div className="navy-line" />
                <h1>Contact Us</h1>
              </div>
            </div>
            <div className="row m-b-lg">
              <div className="col-lg-3"/>
              <div className="col-lg-3">
                <address>
                  <strong><span className="navy">Lac Long Quan Software Solution</span></strong><br/>
                                Tầng 4-6 Số 38/111 Nguyễn Xiển<br/>
                                Hà Nội<br/>
                  <abbr title="Phone">P:</abbr> (+84) 096 1689 001
                </address>
              </div>
              <div className="col-lg-4">
                <p className="text-color">
                                We believe that a company is as good as its people. That is why we employ the best professionals in the industry. We have over 350+ employees worldwide and continue to expand on a quarterly basis.
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 text-center">
                <a href="mailto:contact@llq.vn" className="btn btn-primary">Send us mail</a>
                <p className="m-t-sm">
                                Or follow us on social platform
                </p>
                <ul className="list-inline social-icon">
                  <li><a href="https://www.youtube.com/@LLQQAPlatform"><i className="fa fa-youtube" /></a>
                  </li>&nbsp;&nbsp;
                  <li><a href="https://www.facebook.com/profile.php?id=61578076192885"><i className="fa fa-facebook" /></a>
                  </li>&nbsp;&nbsp;
                  <li><a href="https://www.linkedin.com/in/lac-long-quan/"><i className="fa fa-linkedin" /></a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-2" />
              <div className="col-lg-8 text-center m-t-lg m-b-lg">
                <p><strong>LLQ HRMS &copy; 2025 Lac Long Quan</strong></p>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }

  toggleHover = (event, className) => {
    const active = !!className ? '' : 'active';
    this.setState({ hover: { [event.target.name]: className }, active });
  };

  handleScroll = () => {
    const docElem = document.documentElement;

    setTimeout(scrollPage.call(this), 250);

    function scrollPage() {
      const sy = scrollY();
      this.setState({ headerClass: sy >= this.changeHeaderOn ? 'gray-bg' : '' });
    }

    function scrollY() {
      return window.pageYOffset || docElem.scrollTop;
    }
  };
}
